import { Logo } from '@/components/Logo';
import { usePageContext } from '@/renderer/utils/usePageContext';

import RequestReset from './components/RequestReset';
import SetNewPassword from './components/SetNewPassword';

export default function ForgotPassword() {
  const { urlParsed } = usePageContext();
  const { email, code } = urlParsed.search;

  // Render
  return (
    <div className="flex min-h-full items-center justify-center bg-[Canvas] px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-sm space-y-10">
        <Logo className="mx-auto h-16 w-16 select-none" />
        {!email && !code ? <RequestReset /> : <SetNewPassword email={email} code={code} />}
      </div>
    </div>
  );
}
